// extracted by extract-css-chunks-webpack-plugin
module.exports = {"avatarContainer":"Avatar__avatarContainer___21qrf","avatarIcon":"Avatar__avatarIcon___3e4GN"};
    if(module.hot) {
      // 1778083493227
      var cssReload = require("/home/ubuntu/ideapad-design-changes/ideapad/node_modules/extract-css-chunks-webpack-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hot":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  